// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U0zS1","content":"styles_content__14fvr"};